<template>    
    <b-navbar toggleable="lg" type="light" :variant="pauseOrders ? 'danger' : 'light'" id="navheader" sticky>
        <b-navbar-brand href="#">ClarenMenu 
            <b-button variant="link" size="sm" borderless v-b-tooltip.hover title="Quick Setting" v-b-modal.quickSettingModal>
                <i class="fas fa-sliders-h"></i>
            </b-button>
                <span :class="[{'text-success' : autoConfirmEnabled}, {'text-secondary' : !autoConfirmEnabled}]"><i class="fas fa-circle"></i></span>
        </b-navbar-brand>
        
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    
        <b-collapse id="nav-collapse" is-nav>                
            <b-navbar-nav>
                <b-nav-item to="/">Orders</b-nav-item>
                <b-nav-item-dropdown text="Reports">
                    <b-dropdown-item to="/report/Sales Summary">Sales Summary</b-dropdown-item>
                    <b-dropdown-item to="/report/Sales">Sales</b-dropdown-item>
                    <b-dropdown-item to="/report/Items">Items</b-dropdown-item>
                    <b-dropdown-item to="/report/Lost Sales">Lost Sales</b-dropdown-item>
                    <b-dropdown-item to="/report/Order Efficiency">Order Efficiency</b-dropdown-item> 
                </b-nav-item-dropdown>
                <b-nav-item-dropdown text="Setup">
                    <b-dropdown-item to="/list86">86 List</b-dropdown-item>
                    <b-dropdown-item to="/photo-library">Photos</b-dropdown-item>
                    <b-dropdown-item to="/menu-setup">Menu Setup</b-dropdown-item>
                    <b-dropdown-item to="/menu-editor" v-if="userInfo && canSysAdmin(userInfo)">Menu Spread Sheet</b-dropdown-item>
                    <b-dropdown-item to="/square-setup">Square Setup</b-dropdown-item>
                    <b-dropdown-item to="/stripe-setup">Stripe Setup</b-dropdown-item> 
                </b-nav-item-dropdown>
                <b-nav-item to="/users">Users</b-nav-item>
                <b-nav-item to="/settings">Settings</b-nav-item>
                <b-nav-item-dropdown text="Admin" v-if="userInfo && canSysAdmin(userInfo)">
                    <b-dropdown-item to="/dashboard">Dashboard</b-dropdown-item>
                    <b-dropdown-item to="/organizations">Organization</b-dropdown-item>
                    <b-dropdown-item to="/locations">Locations</b-dropdown-item>                                                                        
                </b-nav-item-dropdown>                    
            </b-navbar-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">                                  
                <b-nav-form>
                    <b-form-select class="mr-sm-2"
                                v-model="selectedOrganization"
                                :options="dataOrganizations"
                                value-field="_id"
                                text-field="name"
                                v-if="userInfo && canSysAdmin(userInfo)"
                                @change="setOrganization"
                                size="sm">  
                                <template #first>
                                    <b-form-select-option :value="null" disabled>Select an organization</b-form-select-option>
                                </template>
                    </b-form-select>
                    <b-form-select class="mr-sm-2"
                                v-if="userInfo && canOrgAdmin(userInfo)"
                                v-model="selectedLocation"
                                :options="dataLocations"
                                value-field="_id"
                                text-field="name"
                                @change="setLocation"
                                size="sm">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>Select an location</b-form-select-option>
                                </template>
                    </b-form-select>
                </b-nav-form>

                <b-nav-item-dropdown right>
                    <template #button-content>
                        <b-icon icon="person-fill" />
                    </template>
                    
                    <b-dropdown-header id="dropdown-header-label" v-if="userInfo && userInfo.name">
                        {{userInfo.name}}
                    </b-dropdown-header>
                    <b-dropdown-divider></b-dropdown-divider>
                        
                    <b-dropdown-item to="/profile" aria-describedby="dropdown-header-label">Profile</b-dropdown-item>
                    <b-dropdown-item @click="onLogout" aria-describedby="dropdown-header-label">Sign Out</b-dropdown-item>
                </b-nav-item-dropdown>  
            </b-navbar-nav>
        </b-collapse>            

        <b-modal id="quickSettingModal" size="sm" scrollable hide-footer title="Quick Setting" v-if="userInfo && userInfo.location">  
            <div>
                <b-form-checkbox v-model="autoConfirmEnabled"                                 
                                 switch>
                                 Auto Confirm
                </b-form-checkbox>
            </div>
            <div>
                <b-form-checkbox v-model="pauseOrders"
                                 switch>
                                 Order Paused
                </b-form-checkbox>
            </div>

            <div>
                <label>Default Time</label>
                <b-form-select 
                    v-model="defaultTime"
                    :options="defaultTimeSlot" size="sm"></b-form-select>
            </div>
            <div class="text-right mt-2">
                <b-button size="sm mx-1" variant="danger" @click="$bvModal.hide('quickSettingModal')">Cancel</b-button>
                <b-button size="sm mx-1" @click="onSubmitLocation">Ok</b-button>
            </div>
        </b-modal>
    </b-navbar>
</template>
<script>
import Swal from 'sweetalert2'
import { mapState } from 'vuex'

const defaultTimeSlot = new Array(9).fill(1).map((x, index) => { return { value : (index + 1) * 5,  text : `${(index + 1) * 5} Minutes` } });

export default {
    props : [ "appbus" ],
    computed: { 
        ...mapState({
            userInfo:"userInfo"
        }),
        autoConfirmEnabled: {
            get() {
                return this.userInfo && this.userInfo.location && this.userInfo.location.autoConfirmEnabled
            },
            set(newValue) {
                this.tmpLocData["autoConfirmEnabled"] = newValue
            }
        },
        pauseOrders: {
            get() {
                return this.userInfo && this.userInfo.location && this.userInfo.location.pauseOrders
            },
            set(newValue) {
                this.tmpLocData["pauseOrders"] = newValue
            }
        },
        defaultTime: {
            get() {
                return this.userInfo.location.defaultTime
            },
            set(newValue) {
                this.tmpLocData["defaultTime"] = newValue
            }
        }
	},
    data(){
        return {
            tmpLocData : {},
            selectedOrganization : null,
            selectedLocation : null,
            dataOrganizations : null,
            dataLocations : null,
            defaultTimeSlot : defaultTimeSlot
        }
    },
    watch : {              
        "userInfo.location" : { //Update when location information change from settings
            deep : true,
            immediate : true,
            handler(newValue) {
                if(this.selectedLocation && newValue && newValue._id === this.selectedLocation){//it will saving api call
                    let foundLocation = this.dataLocations.find(({_id}) => this.selectedLocation ===  _id);
                    if(foundLocation) {
                        Object.keys(foundLocation).forEach(key => {
                            foundLocation[key] = newValue[key];
                        })
                    }
                    //  console.log("selectedLocation", newValue);
                    //  this.locations();
                } else { // Update CurrentLocaiton and Current Organization
                    if(this.userInfo.organization) {
                        this.selectedOrganization = this.userInfo.organization._id;
                        this.$store.commit('setSelectedOrganization', this.userInfo.organization);
                    }
                    if(this.userInfo.location) {
                        this.selectedLocation = this.userInfo.location._id;
                        this.$store.commit('setSelectedLocation', this.userInfo.location);
                    }
                }
            }
        },
        selectedLocation : {
            deep : true,
            immediate : true,
            handler() {
                let defaultData = {};
                defaultData.email = this.userInfo.email;
                defaultData.location = this.selectedLocation;
                defaultData.organization = this.selectedOrganization;                                
                this.$store.dispatch('setDefaultData', defaultData);
            }
        },
        selectedOrganization : {
            deep : true,
            immediate : true,
            handler() {
                let defaultData = {};
                defaultData.email = this.userInfo.email;
                defaultData.location = this.selectedLocation;
                defaultData.organization = this.selectedOrganization;                                
                this.$store.dispatch('setDefaultData', defaultData);
            }
        }  
    },   
    methods:{
        onLogout(){
            this.$store.dispatch('apilogOut')
        },
        organizations(){
            this.$store.dispatch('apiOrganization')
                .then(_res => {
                    if(_res.status) {
                        this.dataOrganizations = _res.res
                    }
                }).catch(()=>{
                   
                })
        },
        locations(){
            this.$store.dispatch('apiLocation')
                .then(_res => {
                    if(_res.status) {
                        this.dataLocations = _res.res
                    }
                }).catch(()=>{
                   
                })
        },
        setOrganization(organizationId){
            this.$store.dispatch('apiSetOrganization', organizationId)
                .then(async ({status}) => {
                    if(status){
                        this.locations()
                        let _org = this.dataOrganizations.find(({_id}) => _id === organizationId);
                        this.$store.commit('setSelectedOrganization', _org);
                        await this.$store.dispatch('apiMe');
                    }
                }).catch(()=>{
                   
                })            
        },
        setLocation(locationId){
            let _loc = this.dataLocations.find(({_id}) => _id === locationId);
            this.$store.dispatch('apiSetLocation', _loc)
                .then(async ({status}) => {
                    if(status){
                        this.$store.commit('setSelectedLocation', _loc);
                        await this.$store.dispatch('apiMe');
                    }
                }).catch(()=>{
                   
                })            
        },
        async onSubmitLocation() {
           const _location =  this.userInfo.location

           Object.entries(this.tmpLocData).forEach(([key, value]) => {
               _location[key] = value
            });

           this.$store.dispatch('apiEditLocation', _location)
                    .then(({status, error}) => {
                        if(!status)  {
                            console.error("error",error)
                            Swal.fire('Error',error.msg,'error')
                        }else{
                            this.$bvModal.hide('quickSettingModal')
                        }
                    })
                    .catch(({error, msgError})=>{
                        console.error("apiEditLocation-E", error)  
                        Swal.fire('Error',msgError,'error')   
                    })            
        }
    },
    mounted() {
        if(this.userInfo.organization) {
            this.selectedOrganization = this.userInfo.organization._id;
            this.$store.commit('setSelectedOrganization', this.userInfo.organization);
        }
        if(this.userInfo.location) {
            this.selectedLocation = this.userInfo.location._id;
            this.$store.commit('setSelectedLocation', this.userInfo.location);
        }
        this.organizations()
        this.locations()
        this.appbus.$on("updateHeaderLocations", ()=>{ this.locations() })
        this.appbus.$on("updateHeaderOrganizations", ()=>{ this.organizations() })
    },
    destroyed() {
        if(this.appbus) {
            this.appbus.$off('updateHeaderLocations');
            this.appbus.$off('updateHeaderOrganizations');        
        }
    },     
}
</script>